import services from "services";

import encodeQueryParams from "common/encode-query-params";

import END_POINT_PATH from "constants/end-point-path";

// dto
import ResourceDataDto from "dto/services/resource-data-dto";
import PageConnectWithUsDto from "dto/pages/page-connect-with-us-dto";

const language = (value: string) => { return { headers: { "x-lang": value } }};

const api = {
	get: {
		solutions: {
			solutions: (params: { param: string; size: number; page: number }) => services.get(END_POINT_PATH.SOLUTIONS.SOLUTIONS + encodeQueryParams(params)),
			solutionTitle: (lang: string) => services.get(END_POINT_PATH.SOLUTIONS.SOLUTION_TITLE, { ...language(lang) }),
			brochure: (type: string, params: { size: number; page: number }, lang: string) => services.get(END_POINT_PATH.SOLUTIONS.BROCHURE + `${type}` + encodeQueryParams(params), { ...language(lang) }),
		},
		faq: {
			faq: (lang: string) => services.get(END_POINT_PATH.FAQ.FAQ, { ...language(lang) }),
		},
		ourArticles: {
			ourArticles: (params: { param: string; size: number; page: number }) => services.get(END_POINT_PATH.ARTICLE.OUR_ARTICLES + encodeQueryParams(params)),
			allArticles: (params: { param: string; size: number; page: number }, lang: string) => services.get(END_POINT_PATH.ARTICLE.ALL_ARTICLES + encodeQueryParams(params), { ...language(lang) }),
			latestArticles: (params: { param: string; size: number; page: number }, lang: string) => services.get(END_POINT_PATH.ARTICLE.LATEST_ARTICLES + encodeQueryParams(params), { ...language(lang) }),
		},
		clients: {
			client: (id: string) => services.get(END_POINT_PATH.CLIENTS.CLIENT + id),
			clients: (params: { size: number; page: number }, lang: string) => services.get(END_POINT_PATH.CLIENTS.CLIENTS + encodeQueryParams(params), { ...language(lang) }),
		},
		partner: {
			partner: () => services.get(END_POINT_PATH.PARTNER.PARTNER),
		},
		articleDetails: {
			article: (id: string) => services.get(END_POINT_PATH.ARTICLE.ARTICLE_DETAILS + id),
		},
		similarArticle: {
			article: (category: string, params: { page: number; size: number }, lang: string) => services.get(END_POINT_PATH.ARTICLE.SIMILAR_ARTICLE + `${category}` + encodeQueryParams(params), { ...language(lang) }),
		},
		similarCategory: {
			article: (id: string, category: string, params: { page: number; size: number }) => services.get(END_POINT_PATH.ARTICLE.SIMILAR_CATEGORY(id, category) + encodeQueryParams(params)),
		},
		services: {
			services: (id: string, params: { size: number; page: number }, lang: string) => services.get(END_POINT_PATH.SERVICES.SERVICES + `${id}` + encodeQueryParams(params), { ...language(lang) }),
			servicesCard: (id: string, params: { size: number; page: number }, lang: string) => services.get(END_POINT_PATH.SERVICES.SERVICES_CARD + `${id}` + encodeQueryParams(params), { ...language(lang) }),
		},
		categoryTitle: {
			categoryTitle: (params: { page: number; size: number }, lang: string) => services.get(END_POINT_PATH.ARTICLE.CATEGORY_TITLE + encodeQueryParams(params), { ...language(lang) }),
		},
		dropdown: {
			retrieveCategory: (category: string, params: { page: number; size: number }) => services.get(END_POINT_PATH.DROPDOWN.RETRIEVE_CATEGORY + `${category}` + encodeQueryParams(params)),
		},
		branches: (status: string, params: { page: number; size: number }, lang: string) => services.get(`${END_POINT_PATH.BRANCH.BRANCH}/${status}` + encodeQueryParams(params), { ...language(lang) }),
		career: {
			career: (params: { param: string; size: number; page: number }) => services.get(END_POINT_PATH.CAREER.CAREER + encodeQueryParams(params)),
			hiring: () => services.get(END_POINT_PATH.CAREER.HIRING),
			position: () => services.get(END_POINT_PATH.CAREER.POSITION),
			hiringSearch: (params: { size: number; page: number }, lang: string) => services.get(END_POINT_PATH.CAREER.HIRING_SEARCH + encodeQueryParams(params), { ...language(lang) }),
		},
		resource: {
			template: () => services.get(END_POINT_PATH.RESOURCE.TEMPLATE),
			resource: (template: string, lang: string) => services.get<ResourceDataDto>(END_POINT_PATH.RESOURCE.RESOURCE(template), { ...language(lang) }),
		},
		story: {
			story: (lang: string) => services.get(END_POINT_PATH.STORY.STORY, { ...language(lang) }),
		},
		announcement: {
			display: (lang: string) => services.get(END_POINT_PATH.ANNOUNCEMENT.DISPLAY, { ...language(lang) }),
		},
	},
	post: {
		contactUs: {
			form: (param: string, formData: PageConnectWithUsDto) => services.post(END_POINT_PATH.CONTACT_US.FORM + `${param}`, formData),
		},
		career: {
			form: (param: string, formData: FormData) => services.post(END_POINT_PATH.CAREER.FORM + `${param}`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
		},
		newsLetter: {
			form: (formData: FormData) => services.post(END_POINT_PATH.NEWSLETTER.FORM, formData),
		},
	},
	patch: {},
	put: {},
};

export default api;
